module.exports = __webpack_public_path__ + "img/highlights-card.57ffbe22.png";